
export default {
	products: [],
	categories: [],
	roles: [],
	ccostos: [],
	loaders: [],
	
}